import React, { use, useEffect, useState } from 'react';
import usePageTitle from '../../utils/usePageTitle';
import { Button, Divider, Layout, Menu, Spin, theme, Space } from 'antd';
import '../../style/component.css'
import Headers from '../header/Header';
import { Navigate, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/authContext';
import { fetchProfile } from '../../service/api';
import AdminSidebarMenu from '../sidebar/AdminSidebarMenu';
import {
    ClockCircleOutlined,
    SafetyOutlined,
} from "@ant-design/icons";
const { Content, Footer } = Layout;


const MainLayouts = () => {
    const location = useLocation();
    const navigate = useNavigate()
    const { token, getCurrentUser } = useAuth()
    const [isLoading, setIsLoading] = useState(false)

    const getProfile = async () => {
        setIsLoading(true)
        try {
            const res = await fetchProfile()
            if (res.status === 200) {
                const fetchData = res.data.data
                getCurrentUser(fetchData)
                setIsLoading(false)
            }
        } catch (error) {
            console.log(error)
            setIsLoading(false)
        }
    }

    usePageTitle("Admin")

    useEffect(() => {
        if (token) {
            getProfile()
        }
    }, [token])


    const footerMenus = [
        {
            label: 'Recent Activity',
            path: '/recent-activity',
        },
        {
            label: 'Compliance Status',
            path: '/compliance-status',
        },
        {
            label: 'Waitlist Children',
            path: '/waitlist-children',
        },
        {
            label: 'Pending Action',
            path: '/pending-action',
        },
        {
            label: 'Leave Calender',
            path: '/leave-calender',
        },
    ];

 

    return (
        <Layout>
            <Headers setIsLoading={setIsLoading} />
            <Layout>
                <AdminSidebarMenu />
                <Layout className='main'>
                    <Content className='content'>
                        {isLoading ? <Spin size='medium' fullscreen /> :
                            <div style={{ minHeight: "100vh"}}>
                                <Outlet />
                            </div>
                        }

                        <div className="footer-container">
                            <Space wrap>
                                {footerMenus.map((item) => {
                                    const isActive =
                                        location.pathname === item.path;

                                    return (
                                        <Button
                                            key={item.path}
                                            shape="round"
                                            type={isActive ? 'primary' : 'default'}
                                            size='medium'
                                            className={isActive ? 'active-footer-btn' : 'footer-btn'}
                                            onClick={() => navigate(item.path)}
                                        >
                                            {item.label}
                                        </Button>
                                    );
                                })}
                            </Space>
                            <p className="footer-text">
                                © {new Date().getFullYear()} Cubcare. All rights reserved.
                            </p>
                        </div>
                    </Content>
                </Layout>
            </Layout>
        </Layout >
    );

};

export default MainLayouts;
